import React from "react";
import GlobalStyles from "styles/GlobalStyles";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import ComponentRenderer from "ComponentRenderer.js";
import MainLandingPage from "pages/demo/MainLandingPage.js";

import YenimahalleHome from "pages/yenimahalle/Home";
import YenimahalleAlbum from "pages/yenimahalle/Album.js";
import YenimahalleRouting from "pages/yenimahalle/Routing.js";
import YenimahalleContacts from "pages/yenimahalle/Contacts.js";
import YenimahalleList from "pages/yenimahalle/List.js";
import YenimahalleNewsDetails from "pages/yenimahalle/NewsDetails.js";
import MeclisUyeleri from "pages/yenimahalle/MeclisUyeleri.tsx";
import Muhtarlar from "pages/yenimahalle/Muhtarlar";
import TumHaberler from "pages/yenimahalle/TumHaberler";
import BaskanYardimcilari from "pages/yenimahalle/BaskanYardimcilari";
import Duyurular from "pages/yenimahalle/Duyurular";
import HaberDetaylari from "pages/yenimahalle/HaberDetaylari";
import IhaleDuyurulari from "pages/yenimahalle/IhaleDuyurulari";
import BilgiEdinme from "pages/yenimahalle/BilgiEdinme";
import IhaleDetay from "pages/yenimahalle/IhaleDetay";
import BasindaCikanHaberler from "pages/yenimahalle/BasindaCikanHaberler";
import BasindaCikanHaberlerDetay from "pages/yenimahalle/BasindaCikanHaberlerDetay";
import Content from "pages/yenimahalle/Content.tsx";
import Mudurlukler from "pages/yenimahalle/Mudurlukler";
import MudurlukDetay from "pages/yenimahalle/MudurlukDetay";
import Services from "pages/yenimahalle/Services";
import Etkinlikler from "pages/yenimahalle/Etkinlikler";
import EtkinlikDetay from "pages/yenimahalle/EtkinlikDetay";
import Projelerimiz from "pages/yenimahalle/Projelerimiz";
import ProjeDetay from "pages/yenimahalle/ProjeDetay";
import Iletisim from "pages/yenimahalle/Iletisim";
import MeclisGundemi from "pages/yenimahalle/MeclisGundemi";
import MeclisKararlari from "pages/yenimahalle/MeclisKararlari";
import Dev from "pages/yenimahalle/Dev";
import MaliYonetim from "pages/yenimahalle/MaliYonetim";

export default function App() {
  return (
    <>
      <GlobalStyles />
      <Router>
        <Routes>
          {/* <Route path="/components/:type/:subtype/:name" element={<ComponentRenderer />} /> */}
          {/* <Route path="/components/:type/:name" element={<ComponentRenderer />} /> */}
          {/* <Route path="/components" element={<MainLandingPage />} /> */}
          <Route path="/" element={<YenimahalleHome />} />
          {/* <Route path="/yonlendirmeDEMO" element={<YenimahalleRouting />} /> */}
          {/* <Route path="/listeDEMO" element={<YenimahalleList />} /> */}
          {/* <Route path="/rehberDEMO" element={<YenimahalleContacts />} /> */}
          <Route path="/album/:albumId" element={<YenimahalleAlbum />} />
          <Route path="/MaliYonetim/:MaliYonetimTitle/:id" element={<MaliYonetim />} />
          <Route path="/MeclisUyeleri" element={<MeclisUyeleri />} />
          <Route path="/Muhtarlar" element={<Muhtarlar />} />
          <Route path="/BaskanYardimcilari" element={<BaskanYardimcilari />} />
          <Route path="/Mudurlukler" element={<Mudurlukler />} />
          <Route path="/MudurlukDetay/:mudurlukTitle/:id" element={<MudurlukDetay />} />
          <Route path="/Duyurular" element={<Duyurular />} />
          <Route path="/TumHaberler" element={<TumHaberler />} />
          <Route path="/HaberDetay/:haberTitle/:id" element={<HaberDetaylari />} />
          <Route path="/BasindaCikanHaberler" element={<BasindaCikanHaberler />} />
          <Route path="/BasindaCikanHaberler/:header/:id" element={<BasindaCikanHaberlerDetay />} />
          <Route path="/Etkinlikler" element={<Etkinlikler />} />
          <Route path="/EtkinlikDetay/:header/:id" element={<EtkinlikDetay />} />
          <Route path="/haber" element={<YenimahalleNewsDetails />} />
          <Route path="/IhaleDuyurulari" element={<IhaleDuyurulari />} />
          <Route path="/BilgiEdinme" element={<BilgiEdinme />} />
          <Route path="/IhaleDetay/:ihaleID" element={<IhaleDetay />} />
          <Route path="/Icerik/:contentHeader/:contentID" element={<Content />} />
          <Route path="/Yonlendirme/:categoryName/:categoryID" element={<Services />} />
          <Route path="/Projelerimiz/:pageName/:projectType" element={<Projelerimiz />} />
          <Route path="/ProjeDetay/:projectName/:projectID" element={<ProjeDetay />} />
          <Route path="/Iletisim" element={<Iletisim />} />
          <Route path="/MeclisGundemi" element={<MeclisGundemi />} />
          <Route path="/MeclisKararlari" element={<MeclisKararlari />} />

          <Route path="/Dev" element={<Dev />} />

        </Routes>
      </Router>
    </>
  );
}
